export const DAY_OF_WEEK_LABELS = {
  0: '日', 1: '一', 2: '二', 3: '三', 4: '四', 5: '五', 6: '六'
}

/**
 * Format a schedule_rule object into a human-readable string.
 *
 * @param {Object} scheduleRule - { day_of_week, start_time, end_time }
 * @param {Object} [options]
 * @param {string} [options.prefix] - Prefix before day label (e.g., "每週" or "Every ")
 * @returns {string|null}
 */
export function formatSchedulePattern(scheduleRule, { prefix = '每週' } = {}) {
  if (!scheduleRule) return null
  const { day_of_week, start_time, end_time } = scheduleRule
  const dayLabel = DAY_OF_WEEK_LABELS[day_of_week] ?? day_of_week
  const timeRange = end_time ? `${start_time}–${end_time}` : start_time
  return `${prefix}${dayLabel} ${timeRange}`
}
